<template>
  <div class="card">
    <div class="row page-titles">
      <div class="col-md-5 align-self-center">
        <h4 class="text-themecolor">
          <i class="fas fa-vector-square"></i>
          {{ $t('pages.market_sector') }}
        </h4>
      </div>
      <div class="col-md-7 align-self-center text-right">
        <div class="d-flex justify-content-end align-items-center">
          <breadcrumb :parentpage="{'name' : 'market', 'title': $t('pages.market')}" :page="$t('pages.market_sector')" />
        </div>
      </div>
    </div>
    <div>
      <div class="card-body">
        <!-- <ul class="nav nav-tabs customtab" role="tablist">
          <li class="nav-item">
            <a class="nav-link cursor-pointer" :class="{ active: this.sectorSelectedTab === 'sectorIndexes' }"
              @click="() => onSectorSelectedTab('sectorIndexes')">
              <i class="fas fa-indent"></i>
              <span class="hidden-sm-up"> Indexes</span>
              <span class="hidden-xs-down"> Indexes</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link cursor-pointer" :class="{ active: this.sectorSelectedTab === 'sectorRevenue' }"
              @click="() => onSectorSelectedTab('sectorRevenue')">
              <i class="fas fa-file-invoice-dollar"></i>
              <span class="hidden-sm-up"> Revenue</span>
              <span class="hidden-xs-down"> Revenue</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link cursor-pointer" :class="{ active: this.sectorSelectedTab === 'sectorInventory' }"
              @click="() => onSectorSelectedTab('sectorInventory')">
              <i class="fas fa-warehouse"></i>
              <span class="hidden-sm-up"> Inventory</span>
              <span class="hidden-xs-down"> Inventory</span>
            </a>
          </li>
        </ul> -->
        <div class="tab-content">
          <div class="tab-pane" :class="{ active: this.sectorSelectedTab === 'sectorIndexes' }">
            <div class="mt-2 sticky">
              <div>
                <el-select class="" v-model="sectorPeriod" clearable @change="fetchSectorIndexes()">
                  <el-option v-for="item in periodOptions" :key="item.code" :label="item.name" :value="item.code">
                    <span>{{ item.name }}</span>
                  </el-option>
                </el-select>
              </div>
              <div class="mt-2 same-row">
                <loading-container :loading="commonForm.sectorsLoading">
                  <el-select class="" v-model="sectorCode" clearable :placeholder="$t('sector_types.title')"
                    @change="fetchSectorIndexes()">
                    <el-option v-for="item in filterSectorOptions" :key="item.value" :label="item.text"
                      :value="item.value">
                      <span>{{ item.text }}</span>
                      <span class="right-align">
                        <i :class="getSectorIcons(`${item.value}`)"></i>
                      </span>
                    </el-option>
                  </el-select>
                </loading-container>
                <loading-container v-if="industries.length > 0" :loading="commonForm.industriesLoading">
                  <el-select class="" v-model="industryCode" clearable placeholder="Industry"
                    @change="fetchIndustryIndexes()">
                    <el-option v-for="item in filterIndustryOptions" :key="item.value" :label="item.text"
                      :value="item.value">
                      <span>{{ item.text }}</span>
                      <span class="right-align">
                        <i :class="getSectorIcons(`${item.value}`)"></i>
                      </span>
                    </el-option>
                  </el-select>
                </loading-container>
              </div>
            </div>
            <div v-if="sectorIndexChart">
              <loading-container :loading="form.sectorIndexLoading">
                <div class="align-items-center m-t-20 m-b-20 p-positive">
                  <div id="sectorIndexChart">
                    <apexchart type="line" height="350" :options="sectorIndexChart.chartOptions"
                      :series="sectorIndexChart.series" />
                  </div>
                </div>
              </loading-container>
            </div>
            <div v-if="industryIndexChart">
              <loading-container :loading="form.industryIndexLoading">
                <div class="align-items-center m-t-20 m-b-20 p-positive">
                  <div id="industryIndexChart">
                    <apexchart type="line" height="350" :options="industryIndexChart.chartOptions"
                      :series="industryIndexChart.series" />
                  </div>
                </div>
              </loading-container>
            </div>
            <!-- Industry's components -->
            <div v-if="industryCode && industryComponentsChart">
              <loading-container :loading="form.industryComponentsLoading">
                <div class="align-items-center m-t-20 m-b-20 p-positive">
                  <div id="industryComponentsChart">
                    <apexchart type="bubble" height="350" :options="industryComponentsChart.chartOptions"
                      :series="industryComponentsChart.series" />
                  </div>
                </div>
              </loading-container>
            </div>
          </div>
          <div class="tab-pane" :class="{ active: this.sectorSelectedTab === 'sectorRevenue' }">
            Coming soon...
          </div>
          <div class="tab-pane" :class="{ active: this.sectorSelectedTab === 'sectorInventory' }">
            Coming soon...
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Breadcrumb from "@/components/Common/Breadcrumb";
import LoadingContainer from "@/components/Misc/LoadingContainer";
import common from "@/libs/common";
import i18n from '../../i18n';

export default {
  name: "Market",
  components: {
    Breadcrumb,
    LoadingContainer
  },
  beforeMount() {
    this.getCap2GDPChart(this.sectorPeriod);
    if (!this.sectors.length) {
      this.getSectors();
    }
    this.fetchSectorIndexes();
  },
  data() {
    return {
      selectedTab: "bIndicator",
      sectorSelectedTab: 'sectorIndexes',
      bChartPeriod: 12,
      s2bChartPeriod: 12,
      sectorCode: 'ENE',
      industryCode: '',
      sectorPeriod: 'annual',
      periodCap2GDP: 'annual',
      periodCap2Interest: 'annual',
      periodCap2Inflation: 'annual',
      periodCap2Unemployment: 'annual'
    };
  },
  computed: {
    ...mapGetters({
      loading: "market/loading",
      form: "market/form",
      bIndChart: "market/bIndChart",
      s2bIndChart: "market/s2bIndChart",
      sectorIndexChart: "market/sectorIndexChart",
      industryIndexChart: "market/industryIndexChart",
      industryComponentsChart: "market/industryComponentsChart",
      avgBI: "market/avgBI",
      latestBI: "market/latestBI",
      cap2GDPChart: "market/cap2GDPChart",
      avgCap2GDP: "market/avgCap2GDP",
      latestCap2GDP: "market/latestCap2GDP",
      cap2InterestChart: "market/cap2InterestChart",
      avgCap2Interest: "market/avgCap2Interest",
      latestCap2Interest: "market/latestCap2Interest",
      cap2InflationChart: "market/cap2InflationChart",
      avgCap2Inflation: "market/avgCap2Inflation",
      latestCap2Inflation: "market/latestCap2Inflation",
      cap2UnemploymentChart: "market/cap2UnemploymentChart",
      avgCap2Unemployment: "market/avgCap2Unemployment",
      latestCap2Unemployment: "market/latestCap2Unemployment",
      commonLoading: "common/loading",
      commonForm: "common/form",
      sectors: "common/sectors",
      industries: "common/industries",
    }),
    currentPage() {
      return i18n.t(`stocks.information`);
    },
    dailyOptions() {
      return common.getDailyOptions();
    },
    monthlyOptions() {
      return common.getMonthlyOptions();
    },
    periodOptions() {
      return common.getPeriodOptions();
    },
    filterSectorOptions() {
      return this.sectors;
    },
    filterIndustryOptions() {
      return this.industries;
    },
  },
  methods: {
    ...mapActions({
      setField: "market/setField",
      getBIndicator: "market/getBIndicator",
      getS2BIndicator: "market/getS2BIndicator",
      getSectorIndexes: "market/getSectorIndexes",
      getIndustryComponents: "market/getIndustryComponents",
      getIndustryIndexes: "market/getIndustryIndexes",
      getCap2GDPChart: "market/getCap2GDPChart",
      getCap2InterestChart: "market/getCap2InterestChart",
      getCap2InflationChart: "market/getCap2InflationChart",
      getCap2UnemploymentChart: "market/getCap2UnemploymentChart",
      getIndustries: "common/getIndustries",
      getSectors: "common/getSectors",
    }),
    fetchIndustryIndexes() {
      if (this.sectorCode && this.industryCode) {
        let params = {
          'period': this.sectorPeriod,
          'sector': this.sectorCode,
          'industryCode': this.industryCode
        }
        this.getIndustryIndexes(params);
        this.getIndustryComponents(this.industryCode);
      } else {
        let params = {
          'period': this.sectorPeriod,
          'sector': this.sectorCode,
          'industryCode': ''
        }
        this.getIndustryIndexes(params);
      }
    },
    fetchSectorIndexes() {
      this.industryCode = '';
      if (this.sectorCode) {
        this.getIndustries(this.sectorCode);
        let params = {
          'period': this.sectorPeriod,
          'sector': this.sectorCode
        }
        this.getSectorIndexes(params);
        this.getIndustryIndexes(params);
      } else {
        let params = {
          'period': this.sectorPeriod,
          'sector': ''
        }
        this.getSectorIndexes(params);
      }
    },
    getSectorIcons(code) {
      return common.getSectorIcons(code);
    },
    getSectorText(code) {
      return common.getSectorText(code);
    },
    fetchMacroCharts(type) {
      let period = '';
      switch (type) {
        case 'cap2Unemployment':
          period = this.periodCap2Unemployment;
          this.getCap2UnemploymentChart(period);
          break;
        case 'cap2Interest':
          period = this.periodCap2Interest;
          console.log("Period: " + period);
          this.getCap2InterestChart(period);
          break;
        case 'cap2Inflation':
          period = this.periodCap2Inflation;
          this.getCap2InflationChart(period);
          break;
        default:
          period = this.periodCap2GDP;
          this.getCap2GDPChart(period);
          break;
      }
    },
    onChangeS2BChart() {
      let period = 12;
      if (this.s2bChartPeriod) {
        period = this.s2bChartPeriod;
      } else {
        this.s2bChartPeriod = 12;
      }
      this.getS2BIndicator(period);
    },
    onChangeBChart() {
      let period = 12;
      if (this.bChartPeriod) {
        period = this.bChartPeriod;
      } else {
        this.bChartPeriod = 12;
      }
      this.getBIndicator(period);
    },
    collapseSidebar(key) {
      this.setField({ key: key, value: !this.form[key] });
    },
    onSelectedTab(type) {
      this.selectedTab = type;
      this.fetchMacroCharts(type);
    },
    onSectorSelectedTab(type) {
      this.sectorSelectedTab = type;
      switch (type) {
        case 'sectorIndexes':
          this.fetchSectorIndexes();
          break;
        case 'sectorInventory':
          break;

        default:
          break;
      }
    }
  }
};
</script>

<style scoped>
.summary p {
  text-align: center;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}

.ti-close {
  position: absolute;
  right: -12px;
  top: -13px;
  font-weight: bold;
  background: #fff;
  border-radius: 50%;
  padding: 5px;
  cursor: pointer;
  opacity: 0.5;
  transition: ease-in;
}

.ti-close:hover {
  opacity: 1;
  transition: ease-in;
}

.bg-gray {
  background-color: #ddd;
}

td small {
  vertical-align: super;
}

.th-sort {
  position: relative;
  vertical-align: top;
  cursor: pointer;
}

.descending:after {
  content: "\2193";
}

.ascending:after {
  content: "\2191";
}

.ascending:after,
.descending:after {
  display: inline-block;
}
</style>
